import React, { Component } from "react";
import MyFrame from "../components/Frame";
import { Switch, Route, Redirect } from "react-router-dom";
import { app } from "../app";
import "../css/grade.css";
import AraeSet from "./grade/AraeSet";
import PPeType from "./grade/PPeType";
import Organization from "./grade/Organization";
import Duty from "./grade/duty";
import BottomNavigation from "./grade/BottomNavigation";
import shopping from "./grade/shopping";
import talents from "./grade/talents";
import enterprise from "./grade/enterprise";
import commodity from "./grade/commodity"
import HonorWallManage from "./grade/HonorWallManage";

function checkMenu(path) {
  let key = "1";
  switch (path) {
    case "/grade/arae_set":
      key = "1";
      break;
    case "/grade/ppe_type":
      key = "2";
      break;
    case "/grade/organization":
      key = "3";
      break;
    case "/grade/bottom_navigation":
      key = "4";
      break;
    case "/grade/talents":
      key = "5";
      break;
    case "/grade/enterprise":
      key = "6";
      break;
    case "/grade/shopping":
      key = "7";
      break;
    case "/grade/commodity":
      key = "8";
      break;
    case "/grade/duty":
      key = "9";
      break;
  }
  return key;
}

class Grade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu_key: checkMenu(props.location.pathname),
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setData({ menu_key: checkMenu(nextProps.location.pathname) });
    }
  }

  render() {
    let isLogin = app.checkLogin(),
      rights = app.getData("rights");
    if (isLogin) {
      return <Redirect to="/" />;
    } else {
      let { menu_key } = this.state,
        // menuList = [{ key: "1", text: "地区设定", link: "/grade/arae_set" }],
        menuList = [],
        nodeList = [];
        // nodeList = [
        //   <Route key="1" exact path="/grade/arae_set" component={AraeSet} />,
        // ];
      if (rights === 1) {
        menuList.push(
          // { key: "2", text: "技能等级设定", link: "/grade/ppe_type" },
          // { key: "3", text: "技能认证机构", link: "/grade/organization" },
          { key: "4", text: "底部导航设定", link: "/grade/bottom_navigation" },
          { key: "5", text: "人才库管理", link: "/grade/talents" },
          // { key: "6", text: "爱心企业管理", link: "/grade/enterprise" },
          // { key: "7", text: "爱心商城管理", link: "/grade/shopping" },
          // { key: "8", text: "商品兑换管理", link: "/grade/commodity" },
          // { key: "9", text: "值日设置", link: "/grade/duty" }
        );
        nodeList.push(
          // <Route key="2" exact path="/grade/ppe_type" component={PPeType} />,
          // <Route key="3" exact path="/grade/organization" component={Organization}/>,
          <Route key="4" exact path="/grade/bottom_navigation" component={BottomNavigation}/>,
          <Route key="5" exact path="/grade/talents" component={talents} />,
          // <Route key="6" exact path="/grade/enterprise" component={enterprise} />,
          // <Route key="7" exact path="/grade/shopping" component={shopping} />,
          // <Route key="8" exact path="/grade/commodity" component={commodity} />,
          // <Route key="9" exact path="/grade/duty" component={Duty} />,
        );
      }
      // { key: '5', text: '荣誉设定', link: '/grade/honor-wall' },
      /*<Route key="5" exact path="/grade/honor-wall" component={HonorWallManage}/>,*/
      return (
        <MyFrame
          className="grade"
          history={this.props.history}
          menuList={menuList}
          menuSelectKey={menu_key}
        >
          <Switch>
            {nodeList}
            <Route render={() => <Redirect to="/grade/bottom_navigation" />} />
          </Switch>
        </MyFrame>
      );
    }
  }
}

export default Grade;



// WEBPACK FOOTER //
// ./src/routes/Grade.jsx